<div *ngIf="render" fxLayout="column" fxLayoutAlign="center stretch">
  <jazzmo-nieuwsbrief
    (subscribe)="handleSubscribe($event)"
    [lacertaFormSubmitStatus]="lacertaFormSubmitStatus$ | async"
  ></jazzmo-nieuwsbrief>
  <jazzmo-footer-bottom></jazzmo-footer-bottom>
</div>
